var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#3d3d45;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 26,
    height: 20
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0420\u0435\u0441\u0443\u0440\u0441 10ldpi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5,5.47a.5.5,0,1,1,.5-.5.5.5,0,0,1-.5.5M5,2.92A2,2,0,1,0,7,5a2,2,0,0,0-2-2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5,13.86a.5.5,0,1,1,.5-.5.5.5,0,0,1-.5.5m0-2.55a2,2,0,1,0,2,2,2,2,0,0,0-2-2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.45,18.45H13.66v-.89A10.31,10.31,0,0,0,13.54,16a9.24,9.24,0,0,0-2.31-4.87A8.39,8.39,0,0,0,9.91,9.94H17.3c4.08,0,7.15,3.27,7.15,7.62ZM8.56,16.79A5,5,0,0,0,9.64,11.7h0l0,0,.08.08,0,0,.11.11h0l.12.12,0,0,.08.09,0,0,.07.08,0,.05.06.08,0,.06.06.08,0,.06.06.08,0,.06.06.08,0,.06.05.08,0,.06.05.08,0,.07.05.08,0,.07,0,.09,0,.07,0,.09,0,.07,0,.09,0,.06,0,.1,0,.06.05.12,0,0,.07.16v0l.06.14,0,.06,0,.11,0,.07,0,.1,0,.07,0,.1,0,.08,0,.1,0,.08,0,.1,0,.08,0,.1,0,.08,0,.1,0,.08,0,.1L12,16l0,.1v.08l0,.1v.46H8.56ZM5,8.39H5A3.42,3.42,0,1,1,8.38,5,3.42,3.42,0,0,1,5,8.39m0,8.39a3.42,3.42,0,1,1,3.42-3.42A3.42,3.42,0,0,1,5,16.79M17.3,1.55a3.42,3.42,0,0,1,0,6.85H8.56a5,5,0,0,0,0-6.85Zm6.27,9.55a8.33,8.33,0,0,0-3.26-2.18A5,5,0,0,0,17.3,0H5A5,5,0,0,0,2.31,9.17,5,5,0,0,0,5,18.33h7.15V20H26V17.56a9.46,9.46,0,0,0-2.43-6.46",
    transform: "translate(0 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.b8eab556dadb4395fa987ad68d5fb8cd.svg";
export { ForwardRef as ReactComponent };